"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersApi = void 0;
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class UsersApi extends runtime.BaseAPI {
    /**
     * Endpoint to complete the new password setup process
     * Complete new password setup
     */
    completeNewPasswordRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiCompleteNewPasswordRequest'] == null) {
                throw new runtime.RequiredError('apiCompleteNewPasswordRequest', 'Required parameter "apiCompleteNewPasswordRequest" was null or undefined when calling completeNewPassword().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users/complete-new-password`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiCompleteNewPasswordRequestToJSON)(requestParameters['apiCompleteNewPasswordRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiCompleteNewPasswordResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Endpoint to complete the new password setup process
     * Complete new password setup
     */
    completeNewPassword(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.completeNewPasswordRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Endpoint to create a new user
     * Create a new user
     */
    createUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostUserRequest'] == null) {
                throw new runtime.RequiredError('apiPostUserRequest', 'Required parameter "apiPostUserRequest" was null or undefined when calling createUser().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostUserRequestToJSON)(requestParameters['apiPostUserRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Endpoint to create a new user
     * Create a new user
     */
    createUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete a user by email
     */
    deleteUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['email'] == null) {
                throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling deleteUser().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a user by email
     */
    deleteUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteUserRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Retrieve a user by their email address
     * Get user by email
     */
    getUserByEmailRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['email'] == null) {
                throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling getUserByEmail().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiGetUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Retrieve a user by their email address
     * Get user by email
     */
    getUserByEmail(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByEmailRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List users
     */
    listUsersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['page'] != null) {
                queryParameters['page'] = requestParameters['page'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['tenantId'] != null) {
                queryParameters['tenant_id'] = requestParameters['tenantId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiListUsersResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List users
     */
    listUsers() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.listUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates user information including: - First name and last name - Privilege level - Authentication method override settings (is_override_login_method) - Allowed login methods (login_methods)  The is_override_login_method and login_methods fields control user-specific authentication method restrictions.
     * Update a user by email
     */
    updateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['email'] == null) {
                throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling updateUser().');
            }
            if (requestParameters['apiPatchUserRequest'] == null) {
                throw new runtime.RequiredError('apiPatchUserRequest', 'Required parameter "apiPatchUserRequest" was null or undefined when calling updateUser().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/users/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPatchUserRequestToJSON)(requestParameters['apiPatchUserRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPatchUserResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates user information including: - First name and last name - Privilege level - Authentication method override settings (is_override_login_method) - Allowed login methods (login_methods)  The is_override_login_method and login_methods fields control user-specific authentication method restrictions.
     * Update a user by email
     */
    updateUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.UsersApi = UsersApi;
